import { PlayIcon } from '@phosphor-icons/react';
import { formatTimeInHMS, formatTimeInHMSString, formatToISTTime } from '../utils/formatTime';

const SingleQuestionJourney = ({ journeyData }) => {
  return (
    <div className="flex flex-row gap-10 min-w-fit relative">
      {/* Dotted line under images */}
      <div className="absolute top-[27px] left-6 right-8 border-t-2 border-dashed border-[var(--q3-neutral-default)] z-0" />

      {journeyData?.map((question, qIndex, arr) => (
        <div key={qIndex} className="relative flex flex-col justify-center items-center z-10">
          {/* Image */}
          <div className="p-2 rounded-full">
            <img src={question.icon} alt={question.title} />
          </div>

          {/* Text content */}
          <div className="text-center h-[53px]">
            <p className="text-[12px] text-[var(--q3-neutral-default)] font-bold text-nowrap">{question.title}</p>
            <p className="text-[var(--q3-neutral-light)] text-[12px]">{formatToISTTime(question.exactTimeStamp)}</p>
            {formatTimeInHMSString(question.timeSpent) && (
              <p className="text-[var(--q3-neutral-light)] text-[12px] font-medium">
                Spent {formatTimeInHMSString(question.timeSpent)}
              </p>
            )}
          </div>

          {/* Arrow between steps */}
          {qIndex !== journeyData.length - 1 && (
            <div className="absolute top-[21px] right-[-22px] text-[var(--q3-neutral-default)] text-sm">
              <PlayIcon weight="fill" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SingleQuestionJourney;
